import isDemo from '@/lib/utils/is_demo';
import { httpPut, camelify } from '../rest';

export function updateAccount(httpPut, camelify, isDemo) {
  return {
    async execute({
      email,
      firstName,
      lastName,
      phone,
      companyName,
      companyWebsite,
      companyPhone,
      streetAddress,
      province,
      postalCode,
      city,
      defaultFee,
      languagePreference,
    }) {
      let data;
      const params = {
        email,
        first_name: firstName,
        last_name: lastName,
        phone,
        company_name: companyName,
        company_website: companyWebsite,
        company_phone: companyPhone,
        street_address: streetAddress,
        province,
        postal_code: postalCode,
        city,
        default_fee: defaultFee,
        language_preference: languagePreference,
      };
      /* istanbul ignore if */
      if (isDemo()) {
        const file = await import('./fetchAccount.data');
        data = file.default;
      } else {
        try {
          const response = await httpPut('/advisor', params);
          data = camelify(response.data);
        } catch (error) {
          if (error.response && error.response.data && error.response.data.email_exists === true) {
            return {
              emailExists: true,
            };
          }
          throw error;
        }
      }
      return { account: data };
    },
  };
}

export default updateAccount(httpPut, camelify, isDemo);
